export const localeCompare = new Intl.Collator('en', { sensitivity: 'base' }).compare;
